import getConfig from '../config';

const { paymentPlanRoute } = getConfig();

export const HOME = '/';

export const NEW_PAYMENT = '/new';
export const NEW_PAYMENT_REVIEW = `${NEW_PAYMENT}/review`;
export const NEW_PAYMENT_CARD = `${NEW_PAYMENT}/card`;
export const NEW_PAYMENT_BANK = `${NEW_PAYMENT}/bank`;
export const NEW_PAYMENT_CONFIRMATION = `${NEW_PAYMENT}/confirmation`;

export const MOBILE_NEW_PAYMENT = '/mobile/new';
export const MOBILE_NEW_PAYMENT_CARD = `${MOBILE_NEW_PAYMENT}/card`;
export const MOBILE_NEW_PAYMENT_BANK = `${MOBILE_NEW_PAYMENT}/bank`;
export const MOBILE_NEW_PAYMENT_REVIEW = `${MOBILE_NEW_PAYMENT}/review`;
export const MOBILE_NEW_PAYMENT_CONFIRMATION = `${MOBILE_NEW_PAYMENT}/confirmation`;

export const MOBILE_NEW_PAYMENT_METHOD = '/mobile/new/method';

export const MOBILE_DEVICE_NEW = '/mobile/device/new';
export const MOBILE_DEVICE_NEW_CARD = `${MOBILE_DEVICE_NEW}/card`;
export const MOBILE_DEVICE_NEW_BANK = `${MOBILE_DEVICE_NEW}/bank`;
export const MOBILE_DEVICE_NEW_REVIEW = `${MOBILE_DEVICE_NEW}/review`;
export const MOBILE_DEVICE_NEW_CONFIRMATION = `${MOBILE_DEVICE_NEW}/confirmation`;

export const MOBILE_MAINTENANCE_ERROR = '/mobile/maintenance-error';

export const COLLECTIONS = '/collections';
export const COLLECTIONS_REVIEW = `${COLLECTIONS}/review`;
export const COLLECTIONS_CARD = `${COLLECTIONS}/card`;
export const COLLECTIONS_BANK = `${COLLECTIONS}/bank`;
export const COLLECTIONS_CONFIRMATION = `${COLLECTIONS}/confirmation`;

export const PAYMENT_PLAN = paymentPlanRoute; // avoid circle dep
export const PAYMENT_PLAN_REVIEW = `${PAYMENT_PLAN}/review`;
export const PAYMENT_PLAN_CARD = `${PAYMENT_PLAN}/card`;
export const PAYMENT_PLAN_BANK = `${PAYMENT_PLAN}/bank`;
export const PAYMENT_PLAN_CONFIRMATION = `${PAYMENT_PLAN}/confirmation`;

export const ARRANGEMENT = '/arrangement';
export const ARRANGEMENT_NEW = '/arrangement/new';
export const ARRANGEMENT_SPLIT = '/arrangement/split';
export const ARRANGEMENT_SPLIT_NEW = '/arrangement/split/new';
export const ARRANGEMENT_REVIEW = '/arrangement/review';
export const ARRANGEMENT_CONFIRMATION = '/arrangement/confirmation';

export const AUTOPAY = '/autopay';
export const AUTOPAY_EDIT = `${AUTOPAY}/edit`;
export const AUTOPAY_NEW_CARD = `${AUTOPAY_EDIT}/new-card`;
export const AUTOPAY_NEW_BANK = `${AUTOPAY_EDIT}/new-bank`;
export const AUTOPAY_EDIT_CONFIRM = `${AUTOPAY_EDIT}/confirmation`;

export const MOBILE_AUTOPAY = '/mobile/autopay';
export const MOBILE_AUTOPAY_EDIT = `${MOBILE_AUTOPAY}/edit`;
export const MOBILE_AUTOPAY_EDIT_NEW_CARD = `${MOBILE_AUTOPAY_EDIT}/new-card`;
export const MOBILE_AUTOPAY_EDIT_CONFIRM = `${MOBILE_AUTOPAY_EDIT}/confirmation`;
export const MOBILE_AUTOPAY_EDIT_NEW_BANK = `${MOBILE_AUTOPAY_EDIT}/new-bank`;

export const METHODS = '/methods';
export const METHOD_NEW = `${METHODS}/new`;
export const METHOD_NEW_CARD = `${METHOD_NEW}/card`;
export const METHOD_NEW_BANK = `${METHOD_NEW}/bank`;
export const METHOD_EDIT = `${METHODS}/edit/:token`;

export const MOBILE_METHODS = '/mobile/methods';
export const MOBILE_METHOD_NEW = `${MOBILE_METHODS}/new`;
export const MOBILE_METHOD_NEW_CARD = `${MOBILE_METHOD_NEW}/card`;
export const MOBILE_METHOD_NEW_BANK = `${MOBILE_METHOD_NEW}/bank`;

export const NOW_METHODS = '/now/methods';
export const NOW_METHOD_NEW_CARD = `${NOW_METHODS}/new/card`;
export const NOW_METHOD_EDIT = `${NOW_METHODS}/edit/:token`;
export const NOW_METHOD_EDIT_CONFIRM = `${NOW_METHOD_EDIT}/confirmation`;
export const NOW_METHOD_NEW_CARD_CONFIRM = `${NOW_METHOD_NEW_CARD}/confirmation`;

export const ADD_METHOD_STEPUP_ENABLED_ROUTES = [
  METHOD_NEW_CARD,
  METHOD_NEW_BANK,
  NOW_METHOD_NEW_CARD,
];

export const COLLECTIONS_STEPUP_ENABLED_ROUTES = [
  COLLECTIONS_CARD,
  COLLECTIONS_BANK,
];

export const NO_XFINITY_SERVICES = '/no-services';
export const NO_NOW_SERVICES = '/now/no-services';
export const NO_MOBILE_SERVICES = '/mobile/no-services';

export const NO_CONTACT_ERROR = '/nocontact-error';

export const SCHEDULED_PAYMENT = '/scheduled-payments';
export const SCHEDULED_PAYMENT_EDIT = `${SCHEDULED_PAYMENT}/:id`;
export const SCHEDULED_PAYMENT_REVIEW = `${SCHEDULED_PAYMENT_EDIT}/review`;
export const SCHEDULED_PAYMENT_CONFIRM = `${SCHEDULED_PAYMENT}/confirmation`;
export const SCHEDULED_PAYMENT_CANCEL_CONFIRM = `${SCHEDULED_PAYMENT}/cancel-confirmation`;

export const PAYMENT_SETUP = '/payment-setup';

export const TERMS_AUTOPAY = '/terms/autopay';
export const TERMS_STORED_PAYMENT = '/terms/stored-payment';
export const TERMS_ECOBILL = '/terms/ecobill';

export const resolveRoute = (url, params = {}) => url.replace(/:([a-zA-Z]+)/g, (_, sym) => params[sym]);

export const AUTHENTICATION_REQUIRED = '/auth-required';

export const INSTALLMENT = '/installment';
export const INSTALLMENT_NEW = '/installment/new';
export const INSTALLMENT_REVIEW = '/installment/review';
export const INSTALLMENT_CONFIRMATION = '/installment/confirmation';
